import { weddingConfig } from '@/data/weddingConfig';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function Reception() {
  return (
    <section className="relative w-full bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-lg px-6 text-center">
        <ScrollReveal>
          <p className="micro-label mb-5 text-primary-600">02</p>

          <div className="mb-6 flex items-center justify-center">
            <span className="flex h-14 w-14 items-center justify-center rounded-full border border-primary-300/50 sm:h-16 sm:w-16">
              <i className="ri-goblet-line text-xl text-primary-500 sm:text-2xl" />
            </span>
          </div>

          <h2 className="font-heading text-3xl tracking-wide text-foreground-800 sm:text-4xl md:text-5xl">
            Recepción
          </h2>
          <div className="mx-auto mt-5 h-px w-16 bg-primary-300" />
        </ScrollReveal>

        <ScrollReveal delay={1}>
          <div className="mt-10 space-y-4">
            <p className="font-heading text-xl font-light text-foreground-800 sm:text-2xl md:text-3xl">
              {weddingConfig.receptionName}
            </p>
            <p className="font-body text-sm leading-relaxed text-foreground-500 sm:text-base">
              {weddingConfig.receptionAddress}
            </p>
            <p className="font-body text-sm uppercase tracking-[0.2em] text-primary-600 sm:text-base">
              {weddingConfig.receptionTime}
            </p>
          </div>
        </ScrollReveal>

        <ScrollReveal delay={2}>
          <div className="mt-10 md:mt-12">
            <a
              href={weddingConfig.receptionMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline hover:bg-background-50"
            >
              <i className="ri-map-pin-line text-sm" />
              Cómo llegar
            </a>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}